import React from 'react';
import { ArcStack } from '@src/core/ui';
import { AdjustPopup, RuntimeSection } from './components';
import { useMaintenance } from './hooks';

const MaintenancePanel: React.FC = () => {
  const {
    motorItems,
    propellerItems,
    isLoading,
    adjustPopup,
    handleAdjustOptionClick,
    handleReplaceClick,
  } = useMaintenance();

  return (
    <ArcStack>
      <ArcStack direction="row" gap={3}>
        <RuntimeSection
          title="Motor Runtime"
          items={motorItems}
          isLoading={isLoading}
          onAdjustOptionClick={handleAdjustOptionClick}
          onReplaceClick={handleReplaceClick}
        />
        <RuntimeSection
          title="Propeller Runtime"
          items={propellerItems}
          isLoading={isLoading}
          onAdjustOptionClick={handleAdjustOptionClick}
          onReplaceClick={handleReplaceClick}
        />
      </ArcStack>
      {adjustPopup.open && adjustPopup.type != null && (
        <AdjustPopup
          type={adjustPopup.type}
          initialValue={adjustPopup.initialValue}
          open={adjustPopup.open}
          onClose={adjustPopup.onClose}
          onSave={adjustPopup.onSave}
        />
      )}
    </ArcStack>
  );
};

export default MaintenancePanel;
